import { jsx } from "react/jsx-runtime";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
import { copyToClipboard } from "../../../utils/misc.js";
const CopyWrapper = ({ text, onSuccess, onError, className, classes, children }) => {
  const { themeClasses } = useThemePresetClasses("CopyWrapper", classes, className);
  const handleOnCopyClick = async () => {
    if (text === void 0) return;
    try {
      await copyToClipboard(text);
      onSuccess == null ? void 0 : onSuccess();
    } catch (error) {
      onError == null ? void 0 : onError();
    }
  };
  return /* @__PURE__ */ jsx(
    "span",
    {
      onClick: handleOnCopyClick,
      className: cn("w-fit px-2 flex cursor-pointer items-center justify-center", themeClasses == null ? void 0 : themeClasses.root),
      children: children || text
    }
  );
};
const CopyWrapper$1 = CopyWrapper;
export {
  CopyWrapper$1 as default
};
